// Firebase configuration for DentCloud Ads Management
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase (using global Firebase from CDN)
let app, db;

const REQUIRED_FIELDS = ['apiKey', 'authDomain', 'projectId', 'appId'];

const initializeFirebase = () => {
  try {
    const missing = REQUIRED_FIELDS.filter((k) => !firebaseConfig[k]);
    if (missing.length > 0) {
      console.warn(
        `[firebase] Skipping init — missing required env vars: ${missing
          .map((k) => `VUE_APP_FIREBASE_${k.replace(/([A-Z])/g, '_$1').toUpperCase()}`)
          .join(', ')}`
      );
      return { app: null, db: null };
    }

    if (typeof window !== 'undefined' && window.Firebase) {
      app = window.Firebase.initializeApp(firebaseConfig);
      db = window.Firebase.getFirestore(app);
      return { app, db };
    } else {
      console.error('Firebase CDN not loaded. Make sure Firebase scripts are included in index.html');
      return { app: null, db: null };
    }
  } catch (error) {
    console.error('Firebase initialization error:', error);
    return { app: null, db: null };
  }
};

// Auto-initialize when module loads
const { app: firebaseApp, db: firestore } = initializeFirebase();

export { firebaseApp as app, firestore as db, firebaseConfig, initializeFirebase };
